export default [
  {
    title: 'Dashboards',
    icon: 'HomeIcon',
    tagVariant: 'light-warning',
    route: 'dashboard-ecommerce',
  },
  {
    title: 'PPP',
    icon: 'WifiIcon',
    children: [
      {
        title: 'PPP List',
        route: 'isp-username-list',
      },
      {
        title: 'Area Management',
        route: 'isp-area-management',
      },
    ],
  },
  {
    title: 'Invoice',
    route: 'isp-invoice-list',
    icon: 'FileTextIcon',
  },
  {
    title: 'Router Setting',
    icon: 'ZapIcon',
    children: [
      {
        title: 'Router List',
        route: 'isp-router-list',
      },
      {
        title: 'Consistency Center',
        route: 'isp-consistency-center',
      },
    ],
  },
  {
    title: 'Package Setting',
    route: 'isp-package-list',
    icon: 'BookOpenIcon',
  },
  {
    title: 'Mobile Banking',
    route: 'mobile-banking-payment-setting',
    icon: 'CreditCardIcon',
  },
  {
    title: 'Report',
    icon: 'FileTextIcon',
    children: [
        {
          title: 'Date wise Invoice',
          route: 'isp-date-wise-report',
        },
        {
          title: 'Geo Map Report',
          route: 'isp-geo-map-report',
        },
        {
          title: 'Area wise',
          route: 'isp-area-wise-report',
        },
        {
          title: 'New Connection',
          route: 'isp-new-connection-report',
        },
        {
          title: 'Un-Invoiced Users',
          route: 'isp-un-invoiced-report',
        },
        {
          title: 'Duplicate Device',
          route: 'isp-duplicate-device',
        },
        {
          title: 'Notification Metrics',
          route: 'isp-metrics-notification-summary',
        },
    ],
  },
  {
    title: 'Settlement',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Settlement List',
        route: 'isp-settlement-list',
      },
      {
        title: 'Unsettlement List',
        route: 'isp-un-settlement-list',
      },
    ],
  },
  {
    title: 'User Password',
    route: 'isp-user-password-change',
    icon: 'EyeOffIcon',
  },
  {
    title: 'Monthly Bill',
    route: 'service-charge-package-list',
    icon: 'LifeBuoyIcon',
  },
  {
    title: 'Payment History',
    route: 'service-payment-history',
    icon: 'CreditCardIcon',
  },
  {
    title: 'Bulk Notification',
    route: 'isp-bulk-notification',
    icon: 'BellIcon',
  },
  {
    title: 'Ticketing System',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'New Ticket',
        route: 'isp-new-ticket',
      },
      {
        title: 'Ticket List',
        route: 'isp-ticket-list',
      },
      {
        title: 'Department',
        route: 'isp-department-list',
      },
      {
        title: 'Staff',
        route: 'isp-staff-list',
      },
    ],
  },
  {
    title: 'Settings',
    route: 'account-setting',
    icon: 'SettingsIcon',
  },
  {
    title: 'Team Management',
    route: 'isp-team-members',
    icon: 'UsersIcon',
  },
]
